export const EVENTS_LIST = [
	'AD_QUIZ_LP',
	'AD_QUIZ_Q1',
	'AD_QUIZ_Q2',
	'AD_QUIZ_Q3',
	'AD_QUIZ_Q4',
	'AD_QUIZ_Q5',
	'AD_QUIZ_Q6',
	'AD_QUIZ_Q7',
	'AD_QUIZ_Q8',
	'AD_QUIZ_Q9',
	'AD_QUIZ_Q10',
	'AD_QUIZ_Q11',
	'AD_QUIZ_Q12',
	'AD_QUIZ_Q13',
	'AD_QUIZ_Q14',
	'AD_QUIZ_Q15',
	'AD_QUIZ_Q16',
	'AD_QUIZ_LEAD',
	'AD_QUIZ_LEAD_SUBMITTED',
	'AD_QUIZ_SP',

	'AD_QUIZ_CHECKOUT',
	'AD_QUIZ_CHECKOUT_PROMO',

	'AD_QUIZ_INIT_CHECKOUT',
	'AD_QUIZ_INIT_CHECKOUT_PROMO',

	'AD_QUIZ_POPUP_PROMO',
	'AD_QUIZ_POPUP_CONFIRM_PROMO',
	'AD_QUIZ_SP_PROMO',

	'AD_QUIZ_PURCHASE',
	'AD_QUIZ_PURCHASE_PROMO',
];
